import { CSSProperties } from "react";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  fontSize: size.sm,
  color: greys.slate,
};

export const tooltipIcon: CSSProperties = {
  color: greys[3],
  lineHeight: "18px",
};
